import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';

const Wrapper = styled.div`
overflow-x: hidden;
overflow-y: hidden;
width: -webkit-fill-available;
width: -moz-available;
text-align: center;
`;

const CellText = styled.p`
text-transform: uppercase;
opacity: 0.6;
font-size: 10px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.colorTheme.section.titleColor};
display: inline;
`;

const CellImg = styled.img`
src: "${props => props.src}";
width: 80px;
position: fixed;
`;

export function TitleCell({ text, image }) {

    const { currentTheme } = useContext(AppContext);

    return (
        <Wrapper >
            { text &&
                <CellText colorTheme={currentTheme.dashboard}>
                    {text}
                </CellText>
            }
            { image &&
                <CellImg src={image.default} />
            }
        </Wrapper>
    );
}